import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  process.env.TWENTY_API_URL,
  [],
  [ authentication ],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * Retrieves a user's session.
   *
   * @returns {AxiosPromise}
   */
  getSession() {
    return conduit.get('/session', [], []);
  },

  /**
   * Retrieve all countries.
   *
   * @returns {AxiosPromise}
   */
  getCountries() {
    return conduit.get('products/ferry/twenty/countries');
  },

  /**
   * Retrieve all areas for a country.
   *
   * @param country
   * @returns {AxiosPromise}
   */
  getAreasForCountry(country) {
    return conduit.get(`products/ferry/twenty/countries/${country}/areas`);
  },

  /**
   * Retrieve all areas for a country.
   *
   * @param country
   * @returns {AxiosPromise}
   */
  getSites() {
    return conduit.get('products/ferry/twenty/sites');
  },

  /**
   * @returns {AxiosPromise}
   */
  getElcanoTripThemes() {
    return conduit.get('products/products/content/elcano/trip-themes');
  },

  /**
   * @param areaIds
   * @returns {AxiosPromise}
   */
  getCountriesByAreaIds(areaIds) {
    return conduit.post('products/products/sites/by-area-ids', {
      areaIds,
    });
  },

  /**
   * Retrieve all areas for a country.
   *
   * @param type
   * @returns {AxiosPromise}
   */
  getStockPriceProductsForAType(type) {
    return conduit.get(`products/products/stock-price-products/type/${type}`);
  },

  /**
   * Retrieve all areas for a country.
   *
   * @param payload
   * @returns {AxiosPromise}
   */
  getAccommodationCategoriesByProductTypeIds(payload) {
    return conduit.post('products/products/accommodations/categories/by-product-type-ids', payload);
  },

  /**
   * @param countryId
   * @returns {AxiosPromise}
   */
  getExtrasByCountryId(countryId) {
    return conduit.get(`products/products/extras/with-supplier/country/${countryId}`);
  },

  /**
   * @param productTypeId
   * @returns {AxiosPromise}
   */
  getDomainsByProductTypeId(productTypeId) {
    return conduit.get(`core/products/${productTypeId}/domains`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getSuppliersWithCurrencyBySupplierType(masterId) {
    return conduit.post('products/products/suppliers/with-currency', {
      productTypeId: masterId,
    });
  },

  /**
   * @returns {AxiosPromise}
   */
  getCarriers() {
    return conduit.get('products/transports/carriers');
  },

  /**
   * @param type
   * @returns {AxiosPromise}
   */
  getTransitsByType(type) {
    return conduit.get(`products/transports/transits/type/${type}`);
  },

  /**
   * @param transport
   * @returns {AxiosPromise}
   */
  saveBaseTransport(transport) {
    return conduit.post('products/transports/sync', transport, []);
  },

  /**
   * @param transportId
   * @param formData
   * @returns {AxiosPromise}
   */
  uploadContracts(transportId, formData) {
    return conduit.post(`/products/transports/${transportId}/upload/contract`,
      formData,
      {},
      { 'content-type': 'multipart/form-data' }, );
  },

  /**
   * @returns {AxiosPromise}
   */
  getTransportTripSeatingSectionTypes() {
    return conduit.get('/products/transports/seatings/sections/types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getTransportTripConsumableTypes() {
    return conduit.get('/products/transports/consumables/types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getTransportTripUpgradeTypes() {
    return conduit.get('/products/transports/upgrades/types');
  },

  /**
   * @param tripId
   * @param tripSeatings
   * @returns {AxiosPromise}
   */
  syncTransportTripSeatings(tripId, tripSeatings) {
    return conduit.post(`/products/transports/trips/${tripId}/seatings/sync`, tripSeatings);
  },

  /**
   * @param tripId
   * @param tripConsumables
   * @returns {AxiosPromise}
   */
  syncTransportTripConsumables(tripId, tripConsumables) {
    return conduit.post(`/products/transports/trips/${tripId}/consumables/sync`, tripConsumables);
  },

  /**
   * @param tripId
   * @param tripUpgrades
   * @returns {AxiosPromise}
   */
  syncTransportTripUpgrades(tripId, tripUpgrades) {
    return conduit.post(`/products/transports/trips/${tripId}/upgrades/sync`, tripUpgrades);
  },

  /**
   * @param tripId
   * @returns {AxiosPromise}
   */
  getTransportTripSeatingsByTripId(tripId) {
    return conduit.get(`/products/transports/trips/${tripId}/seatings`);
  },

  /**
   * @param tripId
   * @returns {AxiosPromise}
   */
  getTransportTripConsumablesByTripId(tripId) {
    return conduit.get(`/products/transports/trips/${tripId}/consumables`);
  },

  /**
   * @param tripId
   * @returns {AxiosPromise}
   */
  getTransportTripUpgradesByTripId(tripId) {
    return conduit.get(`/products/transports/trips/${tripId}/upgrades`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getTransportLuggageTypes() {
    return conduit.get('/products/transports/luggage/types');
  },

  /**
   * @param transportId
   * @returns {AxiosPromise}
   */
  getTransportLuggage(transportId) {
    return conduit.get(`/products/transports/${transportId}/luggage`);
  },

  /**
   * @param transportId
   * @param transportLuggage
   * @returns {AxiosPromise}
   */
  syncTransportLuggage(transportId, transportLuggage) {
    return conduit.post(`/products/transports/${transportId}/luggage/sync`, transportLuggage);
  },

  /**
   * @param transportId
   * @returns {AxiosPromise}
   */
  getTransportContractsByTransportId(transportId) {
    return conduit.get(`/files/contracts/transport/${transportId}`);
  },

  /**
   * @param transportId
   * @returns {AxiosPromise}
   */
  getNonDynamicTransport(transportId) {
    return conduit.get(`/products/transports/${transportId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getNonDynamicTransports(withDeleted = false) {
    if (withDeleted) {
      return conduit.get('/products/transports/withdeleted');
    }
    return conduit.get('/products/transports');
  },

  /**
   * @param searchBody
   * @returns {AxiosPromise}
   */
  searchTransport(searchBody) {
    return conduit.post('/products/transports/search/with-max-available-allotments',
      searchBody,
      [], );
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItineraryTransfers(itineraryId) {
    return conduit.get(`products/products/extras/by-itinerary/${itineraryId}/transfers`);
  },

  /**
   * @param transportId
   * @returns {AxiosPromise}
   */
  deleteTransport(transportId) {
    return conduit.delete(`/products/transports/${transportId}`);
  },

  getTransportDuration(departureTransitId, departureTime, arrivalTransitId, arrivalTime) {
    const body = {
      departureTransitId,
      departureTime,
      arrivalTransitId,
      arrivalTime,
    };
    return conduit.post('/products/transports/duration', body);
  },

  copyAndTranslateContent(body) {
    return conduit.post('/products/content-replicator/replicate', body);
  },

  /**
   * @param extra
   * @returns {AxiosPromise}
   */
  createNewCustomExtra(extra) {
    return conduit.post('/products/products/extras/custom', extra);
  },

  /**
   * @returns {AxiosPromise}
   */
  getItineraryContracts(itineraryId, domainId) {
    return conduit.get(`/products/itinerary/${itineraryId}/contracts/${domainId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  uploadItineraryContracts(itineraryId, formData) {
    return conduit.post(`/products/itinerary/${itineraryId}/contracts`, formData);
  },

  deleteContract(itineraryId, contractId) {
    return conduit.delete(`/products/itinerary/${itineraryId}/contracts/${contractId}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/twenty-service.js